module.exports = __webpack_public_path__ + "static/img/jxjl2.7c929f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jxjl2.png
// module id = 19sy
// module chunks = 1